export default __webpack_public_path__ + "static/media/banner_exemple.01db1ab2.png";